<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const {t: $t} = useI18n();

defineProps<{ description: string }>();

</script>

<template>
  <div class="intervention-landing-description">
    <h3 class="title">
      {{ $t('summary') }}
    </h3>
    <div v-safe-html="description" class="description"/>
  </div>
</template>

<style scoped lang="scss">

.intervention-landing-description {
  margin: var(--Spacing-spacing-7) var(--Spacing-spacing-8) var(--Spacing-spacing-8) var(--Spacing-spacing-6);
}

.title {
  @include font-h3-bold;
  margin-bottom: var(--Spacing-spacing-4);
}

.description {
  @include font-body;
  max-width: 900px;
}
</style>
